<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-10">
        <div id="page-main">
          <section class="events" id="events">
            <br>
            <h5> {{searchData.length}} results found for "{{searhPhase}}"</h5>
            <hr>
            <!--CSS Loader-->
            <section *ngIf="citeLoader">
              <div class="ph-item" *ngFor="let x of citeRepat">
                <div>
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-10"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-10 empty"></div>
                  </div>
                </div>
              </div>
            </section>
            <!--CSS Loader-->

            <div class="section-content">
              <article class="event" *ngFor="let data of searchData let i=index">
                <aside>
                  <header>
                    <a routerLink="/info/{{data.id}}">
                      <div [innerHTML]="data.title"></div>
                    </a>
                  </header>

                  <div class="additional-info">
                    <span> <span class="fa fa-calendar"></span> {{ data.created_at | date:'MMMM d, y' }}</span>
                  </div>

                </aside>
              </article><!-- /article -->
            </div><!-- /.section-content -->

          </section><!-- /.events -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
